import {
  THEME_AUBERGINE,
  THEME_BLUE,
  THEME_DARK,
  THEME_GHERKIN,
  THEME_HALLOWEEN,
} from "@/app/constants.mjs";

export default {
  [THEME_DARK]: {
    key: THEME_DARK,
    title: "BlitzUI - Dark",
    nameKey: "common:settings.themes.dark",
    nameFallback: "Dark",
    cssClass: "theme-dark",
  },
  [THEME_BLUE]: {
    key: THEME_BLUE,
    title: "BlitzUI - Blue",
    nameKey: "common:settings.themes.blue",
    nameFallback: "Blue",
    cssClass: "theme-blue",
  },
  [THEME_AUBERGINE]: {
    key: THEME_AUBERGINE,
    title: "BlitzUI - Aubergine",
    nameKey: "common:settings.themes.aubergine",
    nameFallback: "🍆",
    cssClass: "theme-aubergine",
  },
  [THEME_GHERKIN]: {
    key: THEME_GHERKIN,
    title: "BlitzUI - Gherkin",
    nameKey: "common:settings.themes.gherkin",
    nameFallback: "🥒",
    cssClass: "theme-gherkin",
  },
  [THEME_HALLOWEEN]: {
    key: THEME_HALLOWEEN,
    title: "BlitzUI - Halloween",
    nameKey: "common:settings.themes.halloween",
    nameFallback: "🎃",
    cssClass: "theme-halloween",
  },
};
